// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"d5d8e8b4","248":"16ee5ffd","429":"8f5dade1","708":"192b33f5","787":"83d46a80","951":"076ea075"}[chunkId] + ".chunk.js";
};